export const RAG_COLORS = {
  green: '#2F9D6D',
  amber: '#FEB700',
  red: '#FF3B30',
};

export const SELECT_ORDER_TYPES_WITH_LABELS = [
  { value: 'all', label: 'All Orders', single: true },
  { value: 'otc', label: 'OTC' },
  { value: 'private', label: 'Private' },
  { value: 'referred', label: 'Referred' },
  { value: 'referred_superdrug', label: 'Referred Superdrug' },
  { value: 'my-gp', label: 'MyGP' },
];


export const SELECT_ORDER_STATUSES_WITH_LABELS = [
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'requested', label: 'New' },
  { value: 'processing', label: 'Pending' },
  { value: 'ready', label: 'Ready' },
  { value: 'declined', label: 'Declined' },
];

export const REPORTS_SELECT_WITH_LABELS = [
  { value: 'orders_in_red', label: 'Pharmacies with Orders in Red' },
  {
    value: 'declined_orders',
    label: 'Pharmacies declining orders in last 7 days',
  },
  {
    value: 'archived_orders',
    label: 'Pharmacies archiving orders in last 7 days',
  },
];

export const DEFAULT_ORDER_TYPE = 'otc';

export const LIVE_DASHBOARD = 'live_dashboard';
export const LIVE_REPORTS = 'live_reports';

export const DASHBOARD_CODES = {
  LIVE_DASHBOARD: 0,
  LIVE_REPORTS: 1,
};

export const ORDER_BY = {
  RAG_STATUS: 'rag_status',
  DATE_CREATED: 'date_created',
};

export const ORDER_TYPES = {
  RX: 'RX',
  OTC_GSL: 'OTC-GSL',
  OTC_PMED: 'OTC - Pmed',
  OTC_RX: 'OTC & RX',
  OTC_RX_PMED: 'OTC & Rx (P-Med)',
};

export const FULFILMENT_TYPES = {
  COLLECTION: 'Collection',
  POSTAL_DELIVERY: 'Postal Delivery',
  PREMIUM_DELIVERY: 'Premium Delivery',
  FREE_DELIVERY: 'Local Delivery',
};

export const checkboxOrderStatuses = [
  { value: 'requested', label: 'New' },
  { value: 'processing', label: 'Processing' },
  { value: 'ready', label: 'Ready' },
  { value: 'done', label: 'Done' },
  { value: 'declined', label: 'Declined' },
  { value: 'all', label: 'All' },
];

export const STATUSES_COUNT = 5;

export const MODAL = {
  PHARMACY_INFO: 0,
  NOTES_LIST: 1,
  ADD_NOTE: 2,
};

export const DASHBOARD_REPORTS_HEADERS = {
  OTC: 'otc',
  REFERRED_DELIVERY: 'referred_delivery',
  REFERRED_COLLECTION: 'referred_collection',
  TOTAL: 'total',
};
